import React, {Component} from 'react';
import { PieChart, Pie, Cell, Tooltip } from 'recharts';
import { getRandomColor } from '../../common/colorUtils';
const RADIAN = Math.PI / 180;


class SimplePieChart extends React.Component {
    constructor(props) {
        super(props);

        this.renderCustomizedLabel = this.renderCustomizedLabel.bind(this);
        this.dataKeyName = this.props.dataKeyName || 'key';
        this.colors = [];
    }

    renderCustomizedLabel(props) {
        let {
            percent,
            color,
            x,
            y,
            textAnchor,
        } = props;

        return (
            <text
                x={x}
                y={y}
                fill={color}
                textAnchor={textAnchor}
            >
                {`${(percent * 100).toFixed(0)}%`}
            </text>
        );
    };

    setSectorColors(data) {
        return data.map((item, key) => {
            if(!this.colors[key]) {
                this.colors[key] = getRandomColor();
            }

            item.color = this.colors[key];
            return item;
        });
    }


    render () {

        let {
            width = 600,
            height = 600,
            outerRadius = 175,
            dataValueName = 'value',
        } = this.props;

        let data = this.props.data.map(item => {
            let clonedItem = {...item};
            clonedItem.name = clonedItem.key;
            return clonedItem;
        });

        data = this.setSectorColors(data);

        return (
            <PieChart width={width} height={height}>
                <Pie
                    data={data}
                    labelLine={true}
                    dataKey={dataValueName}
                    label={this.renderCustomizedLabel}
                    outerRadius={outerRadius}
                    fill="#8884d8"
                    isAnimationActive={false}
                >
                    {
                        data.map((entry, index) => <Cell key={index} fill={entry.color}/>)
                    }
                </Pie>
                <Tooltip/>
            </PieChart>
        );
    }
}

export default SimplePieChart;


// WEBPACK FOOTER //
// ./web/src/components/charts/SimplePieChart.jsx